(function () {
  "use strict";

  // Refonte 2026-09-10 (demande explicite de l'utilisateur) : le tracker ne
  // suit plus QUE une liste fermee d'evenements choisis a la main, plus rien
  // de generique/heuristique en dehors de cette liste. L'ancienne machine a
  // etats de lecture (bandes de vitesse de defilement, confirmation de
  // focus, detection de carrousel/derive, plafond d'inactivite, extraction
  // de texte visible mot par mot) a ete retiree en bloc : c'etait de loin la
  // partie la plus complexe du fichier et la source de la grande majorite
  // des bugs corriges au fil des rounds precedents. La "lecture lente" est
  // desormais un simple minuteur de visibilite (IntersectionObserver) sur
  // une poignee de blocs NOMMES, pas un suivi continu de toute la page.
  //
  // Seule exception, volontairement limitee : la capture d'attribution
  // marketing (premier clic) tourne sur TOUTES les pages du site (voir plus
  // bas), car les parametres UTM d'une pub n'atterrissent presque jamais
  // directement sur Horizon/Alpha. Aucune donnee personnelle. Sur les pages
  // hors Horizon/Alpha ("pages hors produit"), seule la VISITE est
  // enregistree desormais -- plus aucun clic detaille n'y est suivi.
  if (window.__katchTrackerLoaded) return;
  window.__katchTrackerLoaded = true;

  var PAGE_VISIT_ID = generateUuid();

  // ---------------------------------------------------------------------
  // Configuration
  // ---------------------------------------------------------------------
  var CONFIG = {
    endpoints: {
      session: "https://northamerica-northeast1-katch-traffic-intelligence.cloudfunctions.net/ingestSession",
      interactionEvent: "https://northamerica-northeast1-katch-traffic-intelligence.cloudfunctions.net/ingestInteractionEvent",
      adLanding: "https://northamerica-northeast1-katch-traffic-intelligence.cloudfunctions.net/ingestAdLanding",
    },
    mobileMaxWidth: 768,
    sessionTimeoutMs: 30 * 60 * 1000, // 30 min d'inactivite avant nouvelle session

    // Duree minimale (visibilite continue >= 50% du bloc) avant qu'un bloc
    // nomme compte comme "lu lentement" -- aligne sur l'ancien seuil
    // SLOW_READ pour rester comparable.
    slowReadDwellMs: 5000,

    attribution: {
      maxAgeMs: 30 * 24 * 60 * 60 * 1000, // 30 jours
    },
  };

  // ---------------------------------------------------------------------
  // Gating
  // ---------------------------------------------------------------------
  function isMobile() {
    return window.innerWidth <= CONFIG.mobileMaxWidth;
  }

  // Tablette detectee par l'APPAREIL, pas par la largeur d'ecran (ajout du
  // 2026-09-21) : un iPad fait 1024px et passait pour un PC. La largeur
  // continue de choisir le script (mobile <= 768 < desktop) ; ce libelle ne
  // change que le device_type envoye. Un iPad recent (iPadOS 13+) se
  // presente comme un Mac : seul son ecran tactile le trahit.
  function isTabletDevice() {
    var ua = navigator.userAgent || "";
    if (/iPad|Tablet|PlayBook|Silk|Kindle/i.test(ua)) return true;
    if (/Android/i.test(ua) && !/Mobile/i.test(ua)) return true;
    if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return true;
    return false;
  }

  function isProductPage() {
    return window.location.pathname.toLowerCase().indexOf("/products/") !== -1;
  }

  function matchesTargetProduct() {
    var haystack = window.location.href.toLowerCase();
    return haystack.indexOf("horizon") !== -1 || haystack.indexOf("alpha") !== -1;
  }

  // Pages hors produit : seule la VISITE est enregistree (via sendSessionPing
  // plus bas), plus aucune interaction detaillee -- demande explicite de
  // l'utilisateur (liste fermee d'evenements, tous propres a Horizon/Alpha).
  var EXTRA_TRACKED_PATHNAMES = [
    "/pages/manuels-videos",
    "/pages/garantie-katch",
    "/pages/salles-de-montres-ateliers",
    "/pages/a-propos-de-nous",
    "/pages/cliniquekatch",
    "/blogs/articles/formation",
    "/pages/pourquoi-le-fatbike",
    "/pages/nous-ecrire",
  ];

  function isExtraTrackedPage() {
    var pathname = window.location.pathname.toLowerCase().replace(/\/+$/, "");
    return EXTRA_TRACKED_PATHNAMES.indexOf(pathname) !== -1;
  }

  // ---------------------------------------------------------------------
  // Utilitaires generaux
  // ---------------------------------------------------------------------
  function generateUuid() {
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function readJson(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      // localStorage indisponible (navigation privee, etc.)
    }
  }

  function paramOrNull(params, name) {
    var value = params.get(name);
    return value ? value.slice(0, 256) : null;
  }

  // ---------------------------------------------------------------------
  // Attribution marketing (premier clic, sitewide -- inchange)
  // ---------------------------------------------------------------------
  var ATTRIBUTION_STORAGE_KEY = "katch_traffic_attribution";

  function captureCurrentAttribution() {
    var params = new URLSearchParams(window.location.search);
    return {
      landing_page: window.location.href,
      referrer: document.referrer ? document.referrer.slice(0, 2048) : null,
      utm_source: paramOrNull(params, "utm_source"),
      utm_medium: paramOrNull(params, "utm_medium"),
      utm_campaign: paramOrNull(params, "utm_campaign"),
      utm_content: paramOrNull(params, "utm_content"),
      utm_term: paramOrNull(params, "utm_term"),
      gclid: paramOrNull(params, "gclid"),
      fbclid: paramOrNull(params, "fbclid"),
      captured_at: Date.now(),
    };
  }

  function getOrCreateFirstTouchAttribution() {
    var stored = readJson(ATTRIBUTION_STORAGE_KEY);
    var now = Date.now();
    if (stored && stored.captured_at && now - stored.captured_at < CONFIG.attribution.maxAgeMs) {
      return stored;
    }
    var fresh = captureCurrentAttribution();
    writeJson(ATTRIBUTION_STORAGE_KEY, fresh);
    return fresh;
  }

  // ---------------------------------------------------------------------
  // Derniere PUB cliquee (ajout du 2026-09-21, demande explicite de
  // l'utilisateur). La premiere source (ci-dessus) reste figee 30 jours :
  // un visiteur venu la semaine derniere par la pub A, qui revient
  // aujourd'hui par la pub B, restait attribue a A -- ce qui faussait la
  // comparaison entre pubs. Ici, chaque arrivee par un lien de pub (gclid,
  // fbclid, ou utm payant) REMPLACE la precedente, sur toutes les pages du
  // site (les pubs atterrissent sur l'accueil, pas sur les fiches velo).
  // Meme definition de "payant" que classifyAdBucket cote serveur.
  // ---------------------------------------------------------------------
  var LAST_PAID_TOUCH_STORAGE_KEY = "katch_traffic_last_paid_touch";

  function isPaidTouch(touch) {
    var source = (touch.utm_source || "").toLowerCase();
    var medium = (touch.utm_medium || "").toLowerCase();
    return Boolean(
      touch.gclid ||
        touch.fbclid ||
        source.indexOf("cpc") !== -1 ||
        source.indexOf("ads") !== -1 ||
        medium.indexOf("cpc") !== -1 ||
        medium.indexOf("ads") !== -1 ||
        medium.indexOf("paid") !== -1
    );
  }

  function updateLastPaidTouch() {
    var current = captureCurrentAttribution();
    if (isPaidTouch(current)) {
      writeJson(LAST_PAID_TOUCH_STORAGE_KEY, current);
      return current;
    }
    var stored = readJson(LAST_PAID_TOUCH_STORAGE_KEY);
    if (stored && stored.captured_at && Date.now() - stored.captured_at < CONFIG.attribution.maxAgeMs) {
      return stored;
    }
    return null;
  }

  // Version envoyee au serveur : seulement les champs utiles (pas de
  // landing_page/referrer, deja envoyes pour la premiere source).
  function lastPaidTouchPayload() {
    var touch = updateLastPaidTouch();
    if (!touch) return null;
    return {
      utm_source: touch.utm_source,
      utm_medium: touch.utm_medium,
      utm_campaign: touch.utm_campaign,
      utm_content: touch.utm_content,
      utm_term: touch.utm_term,
      gclid: touch.gclid,
      fbclid: touch.fbclid,
      captured_at: touch.captured_at,
    };
  }

  // Arrivee par un lien de pub (ajout du 2026-09-21) : signal leger envoye
  // sur N'IMPORTE QUELLE page (en pratique l'accueil, ou atterrissent les
  // pubs) pour mesurer l'entree de l'entonnoir, par groupe de pub. Les deux
  // scripts (mobile/desktop) tournent sur toutes les pages : la garde de
  // largeur ci-dessous evite de compter la meme arrivee deux fois.
  function maybeSendAdLanding() {
    if (!isMobile()) return;
    var current = captureCurrentAttribution();
    if (!isPaidTouch(current)) return;
    fetch(CONFIG.endpoints.adLanding, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        path: window.location.pathname.slice(0, 512),
        device_type: isTabletDevice() ? "tablet" : "mobile",
        utm_source: current.utm_source,
        utm_medium: current.utm_medium,
        utm_campaign: current.utm_campaign,
        utm_content: current.utm_content,
        utm_term: current.utm_term,
        gclid: current.gclid,
        fbclid: current.fbclid,
      }),
      keepalive: true,
    }).catch(function () {});
  }

  // ---------------------------------------------------------------------
  // Session (inchange)
  // ---------------------------------------------------------------------
  var SESSION_STORAGE_KEY = "katch_traffic_session";
  var VISITOR_STORAGE_KEY = "katch_traffic_visitor";

  function getVisitorId() {
    var stored = readJson(VISITOR_STORAGE_KEY);
    if (stored && stored.visitor_id) return stored.visitor_id;
    var visitorId = generateUuid();
    writeJson(VISITOR_STORAGE_KEY, { visitor_id: visitorId });
    return visitorId;
  }

  function getOrCreateSession() {
    var now = Date.now();
    var stored = readJson(SESSION_STORAGE_KEY);

    if (stored && stored.session_id && stored.last_activity_at && now - stored.last_activity_at < CONFIG.sessionTimeoutMs) {
      stored.last_activity_at = now;
      writeJson(SESSION_STORAGE_KEY, stored);
      return { session_id: stored.session_id, landing_page: stored.landing_page };
    }

    var session = {
      session_id: generateUuid(),
      landing_page: window.location.href,
      last_activity_at: now,
    };
    writeJson(SESSION_STORAGE_KEY, session);
    return { session_id: session.session_id, landing_page: session.landing_page };
  }

  // getOrCreateSession() ne rafraichit last_activity_at qu'au CHARGEMENT de
  // page (appelee une seule fois depuis init()) -- un visiteur qui reste
  // engage plus de 30 minutes sur UNE SEULE page (tout a fait plausible
  // avec la lecture lente sur 4 onglets + galerie) puis navigue vers une
  // 2e page se retrouvait dans une NOUVELLE session artificielle, coupant
  // en deux les points d'activite d'un visiteur pourtant tres engage
  // (trouve le 2026-09-11). On retouche donc aussi last_activity_at a
  // chaque interaction reelle, avec un throttle (pas besoin de plus
  // souvent qu'une fois par minute vu la fenetre de 30 minutes).
  var lastActivityTouchAt = 0;
  var ACTIVITY_TOUCH_THROTTLE_MS = 60 * 1000;
  function touchSessionActivity() {
    var now = Date.now();
    if (now - lastActivityTouchAt < ACTIVITY_TOUCH_THROTTLE_MS) return;
    lastActivityTouchAt = now;
    var stored = readJson(SESSION_STORAGE_KEY);
    if (!stored || stored.session_id !== window.__katchSessionId) return;
    stored.last_activity_at = now;
    writeJson(SESSION_STORAGE_KEY, stored);
  }

  // Deux signaux independants, combines en OU (demande explicite du
  // 2026-09-11 : ne pas dependre uniquement de navigator.webdriver) :
  //   1. navigator.webdriver -- mis a true par tout navigateur pilote par
  //      automatisation (Playwright, Selenium, Puppeteer...), sans action du
  //      robot lui-meme.
  //   2. Un marqueur EXPLICITE que seul notre robot QA controle (localStorage
  //      "katch_qa_robot" = "1", pose par le robot via page.addInitScript
  //      avant toute navigation -- voir qa-robot/qa-lib.js). Sert de filet
  //      de securite si jamais navigator.webdriver cesse d'etre fiable
  //      (ex: une future protection anti-detection du navigateur).
  var QA_ROBOT_STORAGE_KEY = "katch_qa_robot";
  function isRobotVisitor() {
    if (navigator.webdriver === true) return true;
    try {
      return window.localStorage.getItem(QA_ROBOT_STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function sendSessionPing(sessionId, landingPage) {
    var attribution = getOrCreateFirstTouchAttribution();
    var payload = {
      session_id: sessionId,
      visitor_id: getVisitorId(),
      page_visit_id: PAGE_VISIT_ID,
      url: window.location.href,
      landing_page: landingPage,
      device_type: isTabletDevice() ? "tablet" : "mobile",
      is_robot: isRobotVisitor(),
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      referrer: attribution.referrer,
      utm_source: attribution.utm_source,
      utm_medium: attribution.utm_medium,
      utm_campaign: attribution.utm_campaign,
      utm_content: attribution.utm_content,
      utm_term: attribution.utm_term,
      gclid: attribution.gclid,
      fbclid: attribution.fbclid,
      last_paid_touch: lastPaidTouchPayload(),
    };

    fetch(CONFIG.endpoints.session, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(function () {});
  }

  // ---------------------------------------------------------------------
  // Bandeau de consentement : reutilise comme garde pour les minuteurs de
  // lecture lente plus bas (evite de compter du temps pendant qu'un bandeau
  // cookies couvre le contenu).
  // ---------------------------------------------------------------------
  var CONSENT_BANNER_RE = /\b(cookies?|t[ée]moins|confidentialit[ée]|consentement|vie priv[ée]e|rgpd|gdpr)\b/i;

  function isConsentBannerBlocking() {
    var points = [
      [window.innerWidth / 2, window.innerHeight * 0.3],
      [window.innerWidth / 2, window.innerHeight * 0.9],
    ];
    for (var p = 0; p < points.length; p++) {
      var el = document.elementFromPoint(points[p][0], points[p][1]);
      var hops = 0;
      while (el && hops < 8) {
        var style = window.getComputedStyle(el);
        if ((style.position === "fixed" || style.position === "sticky") && el.offsetHeight > 40) {
          var text = (el.textContent || "").slice(0, 300);
          if (CONSENT_BANNER_RE.test(text)) return true;
        }
        el = el.parentElement;
        hops++;
      }
    }
    return false;
  }

  // ---------------------------------------------------------------------
  // Envoi des evenements d'interaction
  // ---------------------------------------------------------------------
  // Conversion Google Ads "EngagedVisit" (points >= seuil OU ajout au
  // panier/paiement reussi) -- demande explicite de l'utilisateur
  // (2026-09-15) pour completer BikeFirstView (Visit_page_velo, un simple
  // pageview, ~1 clic sur 4) par un signal qui reflete un vrai engagement.
  // Calibre sur les donnees reelles du 12-14 sept : ~20 pts donne environ
  // 2-3 conversions "engagement seul" par jour ; add_to_cart_click (15 pts,
  // sous le seuil) et checkout_click (25 pts, au-dessus) declenchent quand
  // meme toujours la conversion via la regle OR explicite. Un seul
  // evenement gtag par SESSION (pas par page) : marque via
  // localStorage, en plus du comptage "une fois par session" deja
  // configure cote GA4 sur l'evenement cle (meme principe que
  // Visit_page_velo) -- double garde-fou, pas un remplacement l'un de
  // l'autre. Le total de points vient de la reponse serveur
  // (ingestInteractionEvent.ts) plutot que d'etre recalcule ici, pour ne
  // jamais dupliquer/desynchroniser la table de points reelle (shared.ts).
  // ---------------------------------------------------------------------
  var ENGAGED_VISIT_POINTS_THRESHOLD = 20;
  var ENGAGED_VISIT_STORAGE_KEY = "katch_engaged_visit_fired";

  function maybeFireEngagedVisitConversion(interactionType, metadata, responsePoints) {
    var sessionId = window.__katchSessionId;
    if (!sessionId) return;
    var stored = readJson(ENGAGED_VISIT_STORAGE_KEY);
    if (stored && stored.session_id === sessionId) return; // deja declenche cette session

    var crossedThreshold = typeof responsePoints === "number" && responsePoints >= ENGAGED_VISIT_POINTS_THRESHOLD;
    var isCartAddSuccess = interactionType === "add_to_cart_click" && metadata && metadata.success === true;
    // checkout_click depasse deja le seuil de facto (palier a 25 pts, voir
    // shared.ts), mais rendu explicite ici quand meme -- demande explicite
    // de l'utilisateur (2026-09-15) pour que la regle ne depende jamais
    // d'un calcul de points qui pourrait changer plus tard (seuil ajuste,
    // etc.). Meme signal "succes" que le serveur : metadata.cart_nonempty,
    // pas metadata.success (voir ingestInteractionEvent.ts).
    var isCheckoutSuccess = interactionType === "checkout_click" && metadata && metadata.cart_nonempty === true;
    if (!crossedThreshold && !isCartAddSuccess && !isCheckoutSuccess) return;

    writeJson(ENGAGED_VISIT_STORAGE_KEY, { session_id: sessionId, fired_at: Date.now() });
    // Meme visite engagee envoyee au pixel Meta (2026-10-14) -- Meta ne
    // l'avait jamais recue ; trop rare (~37/sem.) pour optimiser dessus,
    // mais utile a observer. Voir aussi maybeFireQualifiedVisitMeta.
    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", "EngagedVisit", { points: responsePoints });
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "engaged_visit");
      // Action de conversion Google Ads "Visite engagee (engaged_visit)"
      // (creee le 2026-09-15, categorie Clic sortant/Engagement, ocid
      // 588945488) -- gtag('event','engaged_visit') seul ne compte PAS
      // comme conversion cote Google Ads, contrairement a un evenement GA4 :
      // il faut le send_to explicite fourni par l'assistant de creation.
      window.gtag("event", "conversion", { send_to: "AW-499140043/CGI5CI3NqPgcEMuLge4B" });
    }
  }

  // Niveau intermediaire pour Meta (2026-10-14, demande de l'utilisateur) :
  // BikeFirstView (fiche ouverte) est trop facile, EngagedVisit (20 pts)
  // trop rare pour l'apprentissage Meta (~50 evenements/semaine/ensemble).
  // Mesure sur 464 visites Facebook (30 sept.-13 oct.) : >= 10 pts = 39 %
  // des visites, ~90/semaine. Futur evenement d'optimisation des campagnes
  // de prospection. Une seule fois par session, comme EngagedVisit.
  var QUALIFIED_VISIT_META_THRESHOLD = 10;
  var QUALIFIED_VISIT_META_STORAGE_KEY = "katch_qualified10_meta_fired";

  function maybeFireQualifiedVisitMeta(responsePoints) {
    var sessionId = window.__katchSessionId;
    if (!sessionId) return;
    if (typeof responsePoints !== "number" || responsePoints < QUALIFIED_VISIT_META_THRESHOLD) return;
    var stored = readJson(QUALIFIED_VISIT_META_STORAGE_KEY);
    if (stored && stored.session_id === sessionId) return; // deja declenche cette session
    if (typeof window.fbq !== "function") return; // pixel pas encore charge : on reessaiera au prochain evenement
    writeJson(QUALIFIED_VISIT_META_STORAGE_KEY, { session_id: sessionId, fired_at: Date.now() });
    window.fbq("trackCustom", "QualifiedVisit10", { points: responsePoints });
  }

  function sendInteractionEvent(interactionType, value, metadata) {
    var payload = {
      session_id: window.__katchSessionId,
      page_visit_id: PAGE_VISIT_ID,
      event_id: generateUuid(),
      url: window.location.href,
      interaction_type: interactionType,
      value: value === undefined ? null : value,
      metadata: metadata || null,
    };

    fetch(CONFIG.endpoints.interactionEvent, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    })
      .then(function (response) {
        return response.json().catch(function () {
          return null;
        });
      })
      .then(function (data) {
        var points = data && typeof data.bike_activity_points === "number" ? data.bike_activity_points : null;
        maybeFireQualifiedVisitMeta(points);
        maybeFireEngagedVisitConversion(interactionType, metadata, points);
      })
      .catch(function () {});
  }

  // Petit garde-fou anti-doublon : un meme theme peut parfois declencher
  // plusieurs evenements (click + change, parent + enfant, listener
  // duplique) pour UNE seule action reelle du visiteur.
  var lastInteractionKey = null;
  var lastInteractionTime = 0;
  var INTERACTION_DEDUPE_MS = 500;

  function sendInteractionEventGuarded(interactionType, value, metadata) {
    touchSessionActivity();
    var key = interactionType + "|" + value;
    var now = Date.now();
    if (key === lastInteractionKey && now - lastInteractionTime < INTERACTION_DEDUPE_MS) return;
    lastInteractionKey = key;
    lastInteractionTime = now;
    sendInteractionEvent(interactionType, value, metadata);
  }

  // ---------------------------------------------------------------------
  // Mots-cles pour couleur / batterie / Katch+ / pneus -- ce sont des
  // controles de variante Shopify standard (swatch/radio/select), la seule
  // facon fiable de savoir LEQUEL a ete choisi est de lire son propre texte
  // ou celui de son groupe d'options.
  // ---------------------------------------------------------------------
  var MAX_INTERACTION_VALUE_WORDS = 10;

  var KATCH_PLUS_RE = /katch\s*\+|katch\s*plus/i;
  var BATTERY_RE = /batt(er|ir)ie|battery|\b\d{2,3}\s?v\b|\b\d{1,3}\s?ah\b|\b\d{3,5}\s?wh\b/i;
  var TIRE_RE = /pneus?|tires?|maxxis|schwalbe|\bvee\b|kenda|michelin/i;
  var GALLERY_ITEM_RE = /thumb|dot|pagination|gallery__item|gallery-item/i;
  var GALLERY_CONTEXT_RE = /galerie|gallery|media|photo|image/i;
  var EXPERTISE_RE = /expertise katch/i;
  var FACEBOOK_PROMO_RE = /parle de nous|communaut[ée] katch/i;
  var PHONE_PROMO_RE = /commande t[ée]l[ée]phonique/i;

  // ---------------------------------------------------------------------
  // Blocs connus (selecteur + mot-cle de confirmation quand plusieurs
  // cartes partagent la meme classe generique "icon-txt") -- liste fermee,
  // exactement les elements demandes, verifiee contre le vrai DOM le
  // 2026-09-10.
  // ---------------------------------------------------------------------
  var KNOWN_BLOCK_PATTERNS = [
    { type: "expertise_click", selector: ".katch-expertise", re: EXPERTISE_RE, value: "L'expertise Katch" },
    { type: "facebook_promo_click", selector: ".icon-txt", re: FACEBOOK_PROMO_RE, value: "On parle de nous sur Facebook" },
    { type: "phone_promo_click", selector: ".icon-txt", re: PHONE_PROMO_RE, value: "Commande téléphonique 7 jours sur 7" },
    {
      type: "video_consultation_click",
      selector: 'a[href="/pages/essai-video-en-direct"], a[href="https://katchfatbike.com/pages/essai-video-en-direct"]',
      value: "Essai vidéo en direct",
    },
    // "Financement disponible -- contactez-nous pour faire votre demande."
    // (bloc .finance__note) -- le lien nous-ecrire existe AUSSI ailleurs sur
    // le site (footer), d'ou le scope au conteneur precis plutot qu'au href
    // seul.
    {
      type: "financeit_contact_click",
      selector: '.finance__note a[href="/pages/nous-ecrire"]',
      value: "Contactez-nous (financement)",
    },
    // Accordeon "Avant de reserver -- Essayez-le. Ensuite, decidez." --
    // <div class="kh" role="button" aria-expanded>, detecte par CONTENU
    // (classe trop courte/generique pour etre fiable seule).
    {
      type: "accordion_toggle",
      selector: '[role="button"][aria-expanded], button[aria-expanded]',
      re: /essayez-le/i,
      value: "Avant de réserver — Essayez-le. Ensuite, décidez.",
    },
    // Accordeon "Ce que vous avez pour votre argent" (nouveau, 2026-09) --
    // <button class="kvp-toggle" aria-expanded aria-controls="kvp-panel">,
    // meme logique de detection par contenu.
    {
      type: "accordion_toggle",
      selector: '[role="button"][aria-expanded], button[aria-expanded]',
      re: /ce que vous avez pour votre argent/i,
      value: "Ce que vous avez pour votre argent",
    },
    // "Calculer autonomie +20 Ah" (groupe Systeme Katch+) et "Guide pneus"
    // (groupe Pneus) -- deux liens <a class="helper-chip"> IDENTIQUES en
    // structure, verifies sur le vrai DOM le 2026-09-11 (ajoutes a la
    // demande de l'utilisateur, oublies dans la liste initiale). Selecteur
    // par href exact plutot que par mot-cle generique -- ils vivent tous
    // les deux a l'interieur d'un <label> dont le control est un <select>
    // cache, ce qui exige aussi le fix du garde-fou "clic dans un label"
    // plus bas (sinon le clic est avale avant meme d'atteindre ce
    // classificateur).
    { type: "range_calculator_open", selector: 'a.helper-chip[href="/pages/katchplus"]', value: "Calculer autonomie +20 Ah" },
    { type: "tire_guide_open", selector: 'a.helper-chip[href="/pages/pneus"]', value: "Guide pneus" },
    // Bouton geolocalisation dans l'accordeon "Avant de reserver" --
    // <button id="ktG" title="Utiliser ma position">, id stable verifie
    // sur le vrai DOM (section custom-codee, pas un token Shopify genere).
    { type: "geolocation_click", selector: "#ktG", value: "Utiliser ma position" },
  ];

  function classifyKnownBlockClick(target) {
    if (!target.closest) return null;
    for (var i = 0; i < KNOWN_BLOCK_PATTERNS.length; i++) {
      var p = KNOWN_BLOCK_PATTERNS[i];
      var container = target.closest(p.selector);
      if (!container) continue;
      if (p.re && !p.re.test(container.textContent || "")) continue;
      return { type: p.type, value: p.value };
    }
    return null;
  }

  // Liens "Fiche avancee (technique) -->" (moteur, batterie) -- le TEXTE du
  // lien est generique et identique partout, seul l'aria-label identifie le
  // composant ("Ouvrir la fiche technique avancee DU MOTEUR BAFANG G063").
  var ADVANCED_INFO_LABEL_PREFIX_RE = /^ouvrir la fiche technique avanc[ée]e (du|de la|de l['’])\s*/i;

  function classifyAdvancedInfoLink(target) {
    var link = target.closest && target.closest("a.info-advanced");
    if (!link) return null;
    var label = (link.getAttribute("aria-label") || link.textContent || "").replace(/\s+/g, " ").trim();
    label = label.replace(ADVANCED_INFO_LABEL_PREFIX_RE, "").trim();
    return { value: label || "Fiche avancée" };
  }

  // "Katch Bike Explorer" : carte interactive (image 360 + hotspots
  // cliquables) qui remplace tranquillement les liens "Fiche avancee"
  // ci-dessus, page par page (ajoutee par le frere de l'utilisateur, en
  // deploiement le 2026-09-16 -- coexiste avec les liens sur certaines
  // pages en transition). Un hotspot est un <button data-kbe-open="..."
  // aria-label="Decouvrir XYZ">, verifie sur le vrai DOM le 2026-09-16.
  var HOTSPOT_LABEL_PREFIX_RE = /^d[ée]couvrir\s+/i;
  // Un MEME composant s'ouvre de deux facons, avec deux libelles differents
  // (verifie sur le vrai DOM le 2026-09-20) : le point sur le velo porte
  // aria-label="Decouvrir Moteur Bafang", le bouton de la liste sous le velo
  // n'a pas d'aria-label et affiche "01 Moteur Bafang 3D" (numero d'ordre +
  // badge 3D). Sans normalisation, le meme composant compterait comme deux
  // entrees distinctes dans le classement ET consommerait les deux credits
  // de points de la page.
  var HOTSPOT_LEADING_NUMBER_RE = /^\d+\s+/;
  var HOTSPOT_TRAILING_3D_RE = /\s*3d\s*$/i;

  function normalizeHotspotLabel(raw) {
    return String(raw || "")
      .replace(/\s+/g, " ")
      .trim()
      .replace(HOTSPOT_LABEL_PREFIX_RE, "")
      .replace(HOTSPOT_LEADING_NUMBER_RE, "")
      .replace(HOTSPOT_TRAILING_3D_RE, "")
      .trim();
  }

  function classifyHotspotOpen(target) {
    var opener = target.closest && target.closest("[data-kbe-open]");
    if (!opener) return null;
    var label = normalizeHotspotLabel(opener.getAttribute("aria-label") || opener.textContent);
    return { value: label || "Composant" };
  }

  // Plafond partage entre l'ancien lien ET le nouveau hotspot -- demande
  // explicite de l'utilisateur (2026-09-16) : max 2 composants DISTINCTS
  // par PAGE (donc 6 pts max, meme plafond que l'ancien systeme a 2 liens
  // moteur+batterie), peu importe que la carte interactive en propose 10 a
  // 12. Reinitialise a chaque chargement de page (variables IIFE simples,
  // pas de localStorage) puisque la carte est propre a CETTE fiche velo.
  // Au-dela du plafond, l'evenement est quand meme ENVOYE, avec
  // metadata.scored = false : le serveur l'enregistre sans accorder de
  // points (voir ingestInteractionEvent.ts). Demande explicite de
  // l'utilisateur (2026-09-20) : garder le plafond de 6 pts par page, mais
  // pouvoir classer TOUS les composants reellement explores -- sinon un
  // visiteur qui en ouvre 8 n'en declarait que 2.
  var MAX_COMPONENT_INTERACTIONS_PER_PAGE = 2;
  var componentInteractionSeenValues = {};
  var componentInteractionCount = 0;

  function maybeSendComponentInteraction(value) {
    if (componentInteractionSeenValues[value]) return;
    componentInteractionSeenValues[value] = true;
    var scored = componentInteractionCount < MAX_COMPONENT_INTERACTIONS_PER_PAGE;
    if (scored) componentInteractionCount++;
    sendInteractionEventGuarded("component_interaction", value, { scored: scored });
  }

  // Rotation 360 de la carte interactive -- glissement (pointerdown ->
  // pointerup) sur le conteneur [data-kbe-viewer], PAS un simple clic sur
  // un hotspot qui vit dans ce meme conteneur (d'ou le seuil de deplacement
  // minimal). Ecoute INDEPENDANTE du script du theme qui fait vraiment
  // tourner le velo (aucun acces a son code, seulement au DOM) -- les deux
  // ecoutent les memes evenements en parallele sans conflit. 1 pt, une
  // seule fois par SESSION (pas par page ni par glissement) -- voir
  // ENGAGED_VISIT_STORAGE_KEY plus haut pour le meme principe de garde.
  var ROTATE_DRAG_THRESHOLD_PX = 15;
  var BIKE_ROTATE_STORAGE_KEY = "katch_bike_rotate_fired";
  var rotateDragStartX = null;

  function maybeFireBikeRotate() {
    var sessionId = window.__katchSessionId;
    if (!sessionId) return;
    var stored = readJson(BIKE_ROTATE_STORAGE_KEY);
    if (stored && stored.session_id === sessionId) return;
    writeJson(BIKE_ROTATE_STORAGE_KEY, { session_id: sessionId, fired_at: Date.now() });
    sendInteractionEventGuarded("bike_rotate", "Rotation 360°");
  }

  function handleBikeExplorerPointerDown(e) {
    var viewer = e.target.closest && e.target.closest("[data-kbe-viewer]");
    rotateDragStartX = viewer ? e.clientX : null;
  }

  function handleBikeExplorerPointerUp(e) {
    if (rotateDragStartX === null) return;
    var deltaX = Math.abs(e.clientX - rotateDragStartX);
    rotateDragStartX = null;
    if (deltaX >= ROTATE_DRAG_THRESHOLD_PX) maybeFireBikeRotate();
  }

  // ---------------------------------------------------------------------
  // Panier / paiement : valent beaucoup de points (15 / 25) et ne doivent
  // compter QUE quand l'etape reussit vraiment. Le vrai theme (Dawn) soumet
  // l'ajout au panier via fetch("/cart/add", ...) -- on intercepte ce MEME
  // fetch pour savoir avec certitude si l'ajout a fonctionne. Le paiement
  // est une vraie soumission de formulaire native qui redirige aussitot --
  // on se fie au nombre d'articles connus dans le panier au moment du clic.
  //
  // cartItemCount demarre a null tant que /cart.js n'a pas repondu -- un
  // clic sur paiement dans cette fenetre (rare mais reel, ex: visiteur
  // rapide qui revient d'une page precedente avec deja des articles) etait
  // toujours compte comme "panier vide" par defaut, perdant les 25 pts pour
  // exactement le visiteur le plus decide (trouve le 2026-09-11). On ne
  // peut pas bloquer la navigation pour attendre une nouvelle reponse
  // reseau au moment du clic -- on reduit donc la fenetre en gardant en
  // cache le dernier compte connu (localStorage), reutilisable des le
  // chargement de la page suivante, avant meme que le fetch de CETTE page
  // reponde.
  // ---------------------------------------------------------------------
  var CART_COUNT_STORAGE_KEY = "katch_traffic_cart_count";
  var cartItemCount = (function () {
    var cached = readJson(CART_COUNT_STORAGE_KEY);
    return cached && typeof cached.count === "number" ? cached.count : null;
  })();

  function setCartItemCount(count) {
    cartItemCount = count;
    writeJson(CART_COUNT_STORAGE_KEY, { count: count });
  }

  function refreshCartItemCount() {
    fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && typeof data.item_count === "number") setCartItemCount(data.item_count);
      })
      .catch(function () {});
  }

  function installCartAddInterceptor() {
    var originalFetch = window.fetch;
    if (typeof originalFetch !== "function") return;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      var method = (init && init.method) || (typeof input === "object" && input.method) || "GET";
      var isCartAdd = url && /\/cart\/add(\.js)?(\?|$)/i.test(url) && /post/i.test(method);
      var fetchPromise = originalFetch.apply(window, arguments);
      if (!isCartAdd) return fetchPromise;

      fetchPromise
        .then(function (response) {
          return response
            .clone()
            .json()
            .then(function (data) {
              var success = !(data && data.status);
              if (success) {
                var qty = (data && data.quantity) || 1;
                setCartItemCount((cartItemCount || 0) + qty);
                sendInteractionEventGuarded("add_to_cart_click", data.product_title || "Ajouter au panier", {
                  success: true,
                });
              } else {
                sendInteractionEventGuarded("add_to_cart_click", (data && data.description) || "Échec", {
                  success: false,
                });
              }
            });
        })
        .catch(function () {});

      return fetchPromise;
    };
  }

  // "success" serait trompeur ici : ceci ne verifie QUE si le panier avait
  // au moins un article au moment du clic, jamais si le paiement a
  // reellement abouti (impossible a savoir cote client, la vraie
  // transaction se passe chez Shopify apres la redirection). cart_nonempty
  // dit exactement ce que c'est.
  function classifyCheckoutClick(target) {
    var btn = target.closest && target.closest('button[name="checkout"]');
    if (!btn) return null;
    var cartNonEmpty = typeof cartItemCount === "number" && cartItemCount > 0;
    return { cart_nonempty: cartNonEmpty };
  }

  // ---------------------------------------------------------------------
  // Couleur / Katch+ / batterie / pneus -- controles de variante Shopify
  // (swatch, radio, select). La valeur cliquee ne porte pas toujours de
  // mot-cle utile (ex: un swatch de couleur sans texte) -- on ajoute alors
  // le nom du GROUPE d'option (legend/label Shopify, ex: "Pneus").
  // ---------------------------------------------------------------------
  // "alt" ajoute apres data-value : un tap direct sur l'<img> d'un swatch
  // (aucun texte propre, aucun des autres attributs) n'a que l'attribut
  // alt pour se decrire -- trouve le 2026-09-11, verifie que l'alt de ces
  // images correspond exactement au libelle du swatch sur ce site.
  function extractValue(el) {
    var value =
      (el.getAttribute && el.getAttribute("aria-label")) ||
      (el.getAttribute && el.getAttribute("data-value")) ||
      (el.getAttribute && el.getAttribute("title")) ||
      (el.getAttribute && el.getAttribute("alt")) ||
      el.value ||
      (el.textContent && el.textContent.trim());
    if (!value) return null;
    value = String(value).replace(/\s+/g, " ").trim();
    if (!value) return null;
    var wordCount = value.split(/\s+/).filter(Boolean).length;
    if (wordCount > MAX_INTERACTION_VALUE_WORDS) return null;
    return value.slice(0, 80);
  }

  function textHint(node) {
    var parts = [];
    if (node.getAttribute) {
      parts.push(node.getAttribute("aria-label") || "");
      parts.push(node.getAttribute("data-value") || "");
      parts.push(node.getAttribute("title") || "");
      parts.push(node.getAttribute("alt") || "");
      parts.push(node.getAttribute("name") || "");
    }
    if (typeof node.value === "string") parts.push(node.value);
    if (typeof node.className === "string") parts.push(node.className);
    // Nettoyer les espaces AVANT de tronquer -- les gabarits Liquid
    // laissent souvent des centaines de caracteres d'espaces/retours de
    // ligne (blocs conditionnels vides) avant le vrai texte ; tronquer
    // brut a 120 caracteres peut alors ne capturer QUE ces espaces et
    // rater completement le texte utile (trouve le 2026-09-11 : un tap sur
    // l'image d'un swatch "Batterie" -- sans data-value propre a cet
    // element -- retombait sur le mot-cle du GROUPE "Systeme Katch+", mal
    // classe en katch_plus au lieu de battery_option).
    if (node.textContent) parts.push(node.textContent.replace(/\s+/g, " ").trim().slice(0, 120));
    return parts.join(" ").toLowerCase();
  }

  function testKeywordRegexes(hint) {
    if (KATCH_PLUS_RE.test(hint)) return "katch_plus";
    if (BATTERY_RE.test(hint)) return "battery_option";
    if (TIRE_RE.test(hint)) return "tire_change";
    return null;
  }

  function classifyByKeywords(ownHint, groupLabel) {
    return testKeywordRegexes(ownHint) || testKeywordRegexes(groupLabel);
  }

  function findOptionGroupLabelText(el) {
    var scope = el;
    var hops = 0;
    while (scope && hops < 8) {
      if (scope.tagName === "FIELDSET" && scope.querySelector) {
        var legend = scope.querySelector("legend");
        if (legend && legend.textContent) return legend.textContent;
      }
      var prev = scope.previousElementSibling;
      if (
        prev &&
        (prev.tagName === "LEGEND" ||
          (typeof prev.className === "string" &&
            (prev.className.toLowerCase().indexOf("label") !== -1 ||
              prev.className.toLowerCase().indexOf("title") !== -1)))
      ) {
        return prev.textContent || "";
      }
      scope = scope.parentElement;
      hops++;
    }
    return "";
  }

  // Classification volontairement etroite : SEULEMENT ce qui sert la liste
  // fermee (couleur/katch+/batterie/pneu, onglets via le motif href="#tab-N"
  // verifie fiable sur le vrai site). Tout le reste de l'ancienne
  // classification generique (details/accordion, role=tab fallback,
  // aria-controls, component_interaction generique) a ete retire -- plus
  // necessaire, et c'etait une source recurrente de faux positifs.
  function classifyInteraction(target) {
    var node = target;
    for (var hops = 0; hops < 10 && node && node.nodeType === 1; hops++, node = node.parentElement) {
      var tag = node.tagName;
      var cls = typeof node.className === "string" ? node.className.toLowerCase() : "";
      var name = (node.getAttribute && node.getAttribute("name")) || "";
      var hint = textHint(node);

      // Le style visuel ("swatch", "color"...) est presque toujours porte
      // par le <label> englobant, pas par l'<input> lui-meme.
      if (tag === "INPUT" && node.closest) {
        var ownLabel = node.closest("label");
        if (ownLabel) {
          if (typeof ownLabel.className === "string") cls += " " + ownLabel.className.toLowerCase();
          hint += " " + textHint(ownLabel);
        }
      }

      // Motif "maison" confirme sur le vrai site : <a href="#tab-3">
      // Specifications</a>, aucun role/aria -- un href commencant par
      // "#tab" + un chiffre est un signal sans ambiguite pour ce motif.
      var href = tag === "A" && node.getAttribute ? node.getAttribute("href") : null;
      if (href && /^#tab[-_]?\d/i.test(href)) {
        return { type: "tab_open", node: node };
      }
      // Un vrai lien de navigation (ex: "Guide pneus" -> /pages/pneus) n'est
      // jamais un controle de variante -- on arrete la remontee ici plutot
      // que de continuer vers un ancetre dont la classe contiendrait par
      // hasard "option"/"variant" (ex: <span class="option-helpers">) et
      // produirait un faux positif.
      if (href) return null;

      var isSwatchLike =
        cls.indexOf("swatch") !== -1 ||
        cls.indexOf("color") !== -1 ||
        name.toLowerCase().indexOf("color") !== -1 ||
        name.toLowerCase().indexOf("couleur") !== -1;
      var hasDataValue = node.getAttribute && node.getAttribute("data-value") !== null;
      var isVariantLike =
        (tag === "INPUT" && (node.type === "radio" || node.type === "checkbox")) ||
        tag === "SELECT" ||
        name.toLowerCase().indexOf("option") !== -1 ||
        cls.indexOf("variant") !== -1 ||
        cls.indexOf("option") !== -1 ||
        (tag === "BUTTON" && hasDataValue);

      if (isSwatchLike || isVariantLike) {
        var groupLabel = findOptionGroupLabelText(node);
        var keywordType = classifyByKeywords(hint, groupLabel.toLowerCase());
        if (keywordType) return { type: keywordType, node: node };
        if (isSwatchLike) return { type: "color_change", node: node };
        return null; // pas de mot-cle reconnu -> hors liste, on ignore
      }
    }

    return null;
  }

  // ---------------------------------------------------------------------
  // Galerie photo (scroll/clic a travers les medias principaux) -- inchange.
  // ---------------------------------------------------------------------
  function classifyGalleryClick(target) {
    var node = target;
    for (var hops = 0; hops < 5 && node && node.nodeType === 1; hops++, node = node.parentElement) {
      var cls = typeof node.className === "string" ? node.className : "";
      if (GALLERY_ITEM_RE.test(cls) && node.parentElement) {
        var siblings = Array.prototype.filter.call(node.parentElement.children, function (c) {
          return c.tagName === node.tagName && GALLERY_ITEM_RE.test(typeof c.className === "string" ? c.className : "");
        });
        if (siblings.length > 1) {
          var index = siblings.indexOf(node);
          if (index === -1) return null;
          return { index: index, total: siblings.length };
        }
      }
    }

    var tablistAncestor = target.closest && target.closest('[role="tablist"]');
    if (tablistAncestor) {
      var tabItem = (target.closest && target.closest('[role="tab"]')) || target;
      var tablistHint =
        ((tablistAncestor.getAttribute && tablistAncestor.getAttribute("aria-label")) || "") +
        " " +
        (typeof tablistAncestor.className === "string" ? tablistAncestor.className : "") +
        " " +
        ((tabItem.getAttribute && tabItem.getAttribute("aria-label")) || "") +
        " " +
        (typeof tabItem.className === "string" ? tabItem.className : "");
      if (GALLERY_CONTEXT_RE.test(tablistHint)) {
        var tabSiblings = Array.prototype.filter.call(tablistAncestor.children, function (c) {
          return c.getAttribute && c.getAttribute("role") === "tab";
        });
        var tabIndex = tabSiblings.indexOf(tabItem);
        return { index: tabIndex === -1 ? 0 : tabIndex, total: tabSiblings.length || 1 };
      }
    }

    return null;
  }

  var seenGalleryIndexes = [];
  function recordGalleryView(index, total) {
    var isReturn = seenGalleryIndexes.indexOf(index) !== -1;
    if (!isReturn) seenGalleryIndexes.push(index);
    sendInteractionEventGuarded("gallery_view", index, { total_images: total, image_return: isReturn });
  }

  // Le slider PRINCIPAL (grandes photos) utilise le defilement horizontal
  // natif (scroll-snap) -- sur mobile, l'action normale est de SWIPE, qui
  // ne declenche aucun clic sur les vignettes ni sur les diapositives
  // elles-memes. classifyGalleryClick (au-dessus) reste utile pour un clic
  // direct sur une vignette, mais rate donc la quasi-totalite des vraies
  // consultations de photos sur mobile (trouve le 2026-09-11 : 12 photos
  // sur cette fiche, quasiment aucune ne generait d'evenement). On observe
  // ici directement les diapositives du slider principal par position
  // reelle a l'ecran -- peu importe la cause du changement (swipe, fleche,
  // vignette) -- verifie que le libelle "is-active" du theme n'est PAS
  // fiable pour ca (ne se met pas a jour sur un simple defilement), d'ou
  // cette mesure geometrique independante. sendInteractionEventGuarded
  // dedoublonne naturellement avec un clic de vignette qui amenerait au
  // meme index.
  function observeGallerySwipe() {
    if (typeof IntersectionObserver === "undefined") return;
    var container = document.querySelector(".product__media-list.slider");
    if (!container) return;
    var slides = Array.prototype.filter.call(container.children, function (c) {
      return c.tagName === "LI";
    });
    if (slides.length < 2) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.5) {
            var index = slides.indexOf(entry.target);
            if (index !== -1) recordGalleryView(index, slides.length);
          }
        });
      },
      { root: container, threshold: [0.5] }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  }

  // Selecteur de region dans l'accordeon "Avant de reserver" -- un vrai
  // <select id="ktR">, verifie sur le vrai DOM le 2026-09-11. Un <select>
  // ne se pilote PAS par "click" (le clic ouvre juste le menu, ne dit rien
  // sur le choix fait) -- il faut ecouter "change", qui ne se declenche
  // qu'une fois la vraie valeur commise. On ignore l'option vide de
  // placeholder ("Choisissez votre region..."). Valeur envoyee = le TEXTE
  // de l'option (le nom de region lisible), pas sa "value" (des
  // coordonnees lat/lon internes).
  function observeRegionSelect() {
    var select = document.getElementById("ktR");
    if (!select) return;
    select.addEventListener("change", function () {
      var option = select.options[select.selectedIndex];
      if (!option || !option.value) return;
      var label = (option.textContent || "").trim();
      if (!label) return;
      sendInteractionEventGuarded("region_selector_change", label);
    });
  }

  function handleInteractionClick(evt) {
    var target = evt.target;
    if (!target || target.nodeType !== 1) return;

    // Un clic a l'interieur d'un <label> associe a un vrai champ de
    // formulaire declenche AUSSI un clic synthetique sur ce champ -- on
    // laisse le second clic (sur le champ reel) faire tout le travail.
    // Exception : un <label> peut aussi contenir un vrai lien/bouton a lui
    // (ex: "Guide pneus" et "Calculer autonomie" vivent dans le <label>
    // du selecteur de variante) -- ce clic-la ne declenche PAS de clic
    // synthetique sur le control du label, il faut donc le laisser passer
    // (trouve le 2026-09-11 : sans cette exception, ces deux liens etaient
    // silencieusement avales ici, avant meme d'atteindre KNOWN_BLOCK_PATTERNS).
    var enclosingLabel = target.closest && target.closest("label");
    var ownActionable = target.closest && target.closest("a[href], button");
    if (enclosingLabel && enclosingLabel.control && enclosingLabel.control !== target && !ownActionable) return;

    var gallery = classifyGalleryClick(target);
    if (gallery) {
      recordGalleryView(gallery.index, gallery.total);
      return;
    }

    var knownBlock = classifyKnownBlockClick(target);
    if (knownBlock) {
      sendInteractionEventGuarded(knownBlock.type, knownBlock.value);
      return;
    }

    var advancedInfo = classifyAdvancedInfoLink(target);
    if (advancedInfo) {
      maybeSendComponentInteraction(advancedInfo.value);
      return;
    }

    var hotspotOpen = classifyHotspotOpen(target);
    if (hotspotOpen) {
      maybeSendComponentInteraction(hotspotOpen.value);
      return;
    }

    var checkout = classifyCheckoutClick(target);
    if (checkout) {
      sendInteractionEventGuarded("checkout_click", "Procéder au paiement", { cart_nonempty: checkout.cart_nonempty });
      return;
    }

    var match = classifyInteraction(target);
    if (!match) return;
    var value = extractValue(match.node);
    if (!value) return;
    sendInteractionEventGuarded(match.type, value);
  }

  // ---------------------------------------------------------------------
  // Lecture lente sur des blocs NOMMES (remplace l'ancien suivi continu de
  // toute la page) : IntersectionObserver + minuteur simple. Un bloc compte
  // comme "lu lentement" s'il reste visible a >= 50% en continu pendant
  // slowReadDwellMs -- une seule fois par page vue, puis on arrete de
  // l'observer. Les panneaux d'onglets sont caches (display:none) tant que
  // l'onglet n'est pas ouvert -- l'observateur ne peut donc jamais se
  // declencher avant l'ouverture reelle, exactement l'ordre attendu.
  // ---------------------------------------------------------------------
  var SLOW_READ_SECTIONS = [
    { selector: ".product-media__features.mobile", label: "Section technique (aperçu rapide)" },
    { selector: "#tab-1", label: "Information" },
    { selector: "#tab-2", label: "Inclus" },
    { selector: "#tab-3", label: "Spécifications" },
    { selector: "#tab-4", label: "Ce qui démarque ce vélo de la compétition" },
  ];

  // IntersectionObserver calcule intersectionRatio par rapport a la hauteur
  // TOTALE du bloc observe, jamais par rapport a l'ecran. Sur mobile,
  // "Specifications" fait ~2183px pour un ecran de ~800px -- meme plein
  // ecran, ce bloc ne peut jamais depasser ~37% de LUI-MEME, donc jamais
  // atteindre 50% : slow_read_section ne se declenchait alors JAMAIS pour
  // ce bloc, peu importe combien de temps un visiteur le lisait (trouve le
  // 2026-09-11, verifie sur le vrai DOM mobile). Fix : comparer la hauteur
  // visible au plus petit des deux (le bloc OU l'ecran) -- un bloc plus
  // haut que l'ecran compte comme "vu" des qu'il remplit au moins la moitie
  // de l'ecran, un bloc plus petit que l'ecran garde l'ancien comportement
  // (au moins la moitie de LUI-MEME visible).
  var DENSE_THRESHOLDS = (function () {
    var arr = [];
    for (var i = 0; i <= 20; i++) arr.push(i / 20);
    return arr;
  })();

  function observeSlowReadSections() {
    if (typeof IntersectionObserver === "undefined") return;

    SLOW_READ_SECTIONS.forEach(function (cfg) {
      var el = document.querySelector(cfg.selector);
      if (!el) return;

      var timer = null;
      var fired = false;
      var lastVisibleEnough = false;

      function clearTimer() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      // setTimeout garde son echeance en temps reel meme si l'ecran est
      // eteint ou l'appli en arriere-plan (le navigateur suspend juste
      // l'execution JS pendant ce temps) : un visiteur qui ouvre Messenger
      // pendant 10s puis revient peut donc declencher le minuteur presque
      // immediatement a son retour, creditant du temps ou la page n'etait
      // meme pas visible. On revalide donc explicitement
      // document.visibilityState a chaque decision, et on ecoute
      // visibilitychange pour arreter/reprendre le minuteur (repart a zero,
      // ne credite jamais le temps passe hors de l'app).
      function evaluate(visibleEnough) {
        lastVisibleEnough = visibleEnough;
        if (visibleEnough && document.visibilityState === "visible" && !isConsentBannerBlocking()) {
          if (!timer) {
            timer = setTimeout(function () {
              fired = true;
              sendInteractionEventGuarded("slow_read_section", cfg.label);
              observer.disconnect();
              document.removeEventListener("visibilitychange", onVisibilityChange);
            }, CONFIG.slowReadDwellMs);
          }
        } else {
          clearTimer();
        }
      }

      function onVisibilityChange() {
        if (fired) return;
        evaluate(lastVisibleEnough);
      }
      document.addEventListener("visibilitychange", onVisibilityChange);

      var observer = new IntersectionObserver(
        function (entries) {
          if (fired) return;
          var entry = entries[0];
          var targetHeight = entry.boundingClientRect.height;
          var visibleHeight = entry.intersectionRect.height;
          var referenceHeight = Math.min(targetHeight, window.innerHeight);
          var visibleEnough = entry.isIntersecting && referenceHeight > 0 && visibleHeight / referenceHeight >= 0.5;
          evaluate(visibleEnough);
        },
        { threshold: DENSE_THRESHOLDS }
      );

      observer.observe(el);
    });
  }

  // ---------------------------------------------------------------------
  // Point d'entree
  // ---------------------------------------------------------------------
  function init() {
    if (!isMobile()) return;

    var isTrackedProduct = isProductPage() && matchesTargetProduct();
    var isExtra = isExtraTrackedPage();
    if (!isTrackedProduct && !isExtra) return;

    var session = getOrCreateSession();
    window.__katchSessionId = session.session_id;
    sendSessionPing(session.session_id, session.landing_page);

    // Pages hors Horizon/Alpha : seule la visite ci-dessus est enregistree.
    if (!isTrackedProduct) return;

    document.addEventListener("click", handleInteractionClick, true);
    document.addEventListener("pointerdown", handleBikeExplorerPointerDown, true);
    document.addEventListener("pointerup", handleBikeExplorerPointerUp, true);
    refreshCartItemCount();
    installCartAddInterceptor();
    observeSlowReadSections();
    observeGallerySwipe();
    observeRegionSelect();
  }

  // Capture d'attribution : AVANT toute porte mobile/page produit, pour
  // qu'elle tourne vraiment sur chaque page du site.
  getOrCreateFirstTouchAttribution();
  updateLastPaidTouch();
  maybeSendAdLanding();

  init();
})();
